/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Tag_WorksInputs */

const en_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployed & Delivered`)
};

const ar_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إطلاقها وتنفيذها`)
};

const bn_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপ্লয়ড ও ডেলিভার্ড`)
};

const de_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitgestellt und geliefert`)
};

const es_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implementado y entregado`)
};

const fr_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déployé et livré`)
};

const pt_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implantado e entregue`)
};

const zh_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已部署和交付`)
};

const tr_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dağıtıldı ve Teslim Edildi`)
};

const ru_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развернуто и доставлено`)
};

const pl_resume_tag_works = /** @type {(inputs: Resume_Tag_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożone i dostarczone`)
};

/**
* | output |
* | --- |
* | "Deployed & Delivered" |
*
* @param {Resume_Tag_WorksInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_tag_works = /** @type {((inputs?: Resume_Tag_WorksInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Tag_WorksInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_tag_works(inputs)
	if (locale === "bn") return bn_resume_tag_works(inputs)
	if (locale === "de") return de_resume_tag_works(inputs)
	if (locale === "es") return es_resume_tag_works(inputs)
	if (locale === "fr") return fr_resume_tag_works(inputs)
	if (locale === "pt") return pt_resume_tag_works(inputs)
	if (locale === "zh") return zh_resume_tag_works(inputs)
	if (locale === "tr") return tr_resume_tag_works(inputs)
	if (locale === "ru") return ru_resume_tag_works(inputs)
	if (locale === "pl") return pl_resume_tag_works(inputs)
	return en_resume_tag_works(inputs)
});